module.exports = __webpack_public_path__ + "img/delete.2655567c.svg";